class ForgotEmailUsersController {
  static controller($scope, $state) {
    'ngInject';

    $scope.forgotEmailSubmit = function (form) {
      switch (form.email.$modelValue) {
        case "qw.er@ty.pl":
          $state.go("public.users.account-confirmation");
          break;
        case "anna.kowalska@gmail.com":
          $state.go("public.users.choose-account");
          break;
        default:
          $state.go("public.users.no-account");
      }
    }
  };
}

export default ForgotEmailUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/forgot-email.users.controller.js